import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { FileModel } from '../models/file.model';

@Injectable()
export class ImageService {

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  getStaticImageURL(file: FileModel): string {
    if (!(file && file.path)) {
      return '';
    }
    return environment.staticBaseUrl + '/' + file.path;
  }

  getAvatarURL(file: FileModel): string {
    if (!(file && file.path)) {
      return environment.staticBaseUrl + '/' + environment.defaultAvatar.path;
    }
    return environment.staticBaseUrl + '/' + file.path;
  }

  getLocalImageURL(file: File): string {
    if (file.type.indexOf('image') === 0) {
      return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file)) as string;
    }
    return 'assets/img/placeholder.jpeg';
  }

}
